export const THREAD_UNAVAILABLE_ALERT = 'thread-unavailable-alert';
export const BULK_UPDATE_FAILURE_ALERT = 'bulk-update-unsuccessful-alert';